import {AudioPlayer} from './classes/AudioPlayer'

const baseUrl = `${import.meta.env.VITE_APP_URL}/obituaries/tts`

const addAudioListeners = (element, player) => {

    element.addEventListener('click', () => player.handleClick())

    const loading = element.querySelector('.loading')
    const playing = element.querySelector('.playing')
    const paused = element.querySelector('.paused')

    player.addEventListener('loading', (e) => {
        loading.classList.remove('hidden')
        playing.classList.add('hidden')
        paused.classList.add('hidden')
    })

    player.addEventListener('playing', () => {
        loading.classList.add('hidden')
        playing.classList.add('hidden')
        paused.classList.remove('hidden')
    })

    player.addEventListener('paused', () => {
        loading.classList.add('hidden')
        paused.classList.add('hidden')
        playing.classList.remove('hidden')
    })

    player.addEventListener('ended', () => {
        loading.classList.add('hidden')
        paused.classList.add('hidden')
        playing.classList.remove('hidden')
    })

}

document.addEventListener('DOMContentLoaded', () => {
    const elements = document.getElementsByClassName('obit-text-tts')
    Array.from(elements).forEach(element => {
        const uuid = element.getAttribute('data-obituary')
        const url = `${baseUrl}/${uuid}`
        const player = new AudioPlayer(url)
        addAudioListeners(element, player)
    })
})
